import Event from '@/types/Event'
import { DateTime } from 'luxon'

export function eventName(event: Event) {
  return `${event.title} (${DateTime.fromSQL(event.dates.start).toFormat('dd/MM/yyyy HH:mm:ss')})`
}
